import cn from 'classnames'
import CartItem from 'modules/cart/components/cart-list-item'
import OrderService from 'modules/cart/services/cart-service'
import { CustomerService } from 'modules/customers/services'
import { FC, useEffect, useState } from 'react'
import { useCart } from 'hooks/use-cart'
import { Button } from 'components/ui'
import { useNotification } from 'hooks/use-notification'
import parseSeller from 'fazendinha/seller'
import { CartProduct } from 'framework/cart'
import { OrderItem } from '..'
import { CartListProps } from '.'
import s from './order-list.module.css'

interface Item {
  id: string
  isAtacado: boolean
  price: number
  quantity?: number
  period?: string
  itemTotal?: number
  type: 'convencional' | 'experiencia'
  delivery_method: string,
  [key: string]: any,
}

const OrderList: FC<CartListProps> = ({ className = '', orders = [] }) => {
  const { notify } = useNotification()
  const { addItem, inCart } = useCart()

  const [ordersList, setOrdersList] = useState<any[]>([] as any)
  const [order, setOrder] = useState<any>(null as any)
  const [abandonedCart, setAbandonedCart] = useState<any>(null as any)
  const [all, setAll] = useState<boolean>(false)

  useEffect(() => {
    if (orders && orders.length > 0) {
      const computedOrders = orders.filter(({ status }) => status !== 'abandoned-cart').slice(0, 5)
      setOrdersList(computedOrders)
      setAbandonedCart(orders.find(({ status }) => status === 'abandoned-cart'))
    } else {
      setOrdersList(orders.filter(({ status }) => status !== 'abandoned-cart'))
      setAbandonedCart(orders.find(({ status }) => status === 'abandoned-cart'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders])

  useEffect(() => {
    if (all) {
      setOrdersList(orders)
    }
  }, [all, orders])

  useEffect(() => {
    if (abandonedCart) {
      const orderId = abandonedCart.id
      const customerService = new CustomerService()
      const orderService = new OrderService(customerService)
      orderService.getOrderItemsById(orderId, setOrder, () => {})
    }
  }, [abandonedCart])

  async function addToCart(orderId: string) {
    const customerService = new CustomerService()
    const orderService = new OrderService(customerService)

    try {
      let orderData: any = null
      await orderService.getOrderItemsById(
        orderId,
        // eslint-disable-next-line no-return-assign
        (x: any) => (orderData = x),
        () => {},
      )

      const products: any[] = orderData

      setTimeout(() => {
        products.forEach((item) => {
          if (!inCart(item.id)) {
            const image = item.images[0]?.nome;
            const productToAdd: Item = {
              ...item,
              assinatura: item.assinatura !== 0,
              type: item.tipo_produto ? item.tipo_produto : 'convencional',
              assinatura_desconto_produtor: item.assinatura_desconto_produtor || 0,
              assinatura_frete_gratis: item.assinatura_frete_gratis || 0,
              assinatura_desconto_frete: item.assinatura_desconto_frete || 0,
              imageUrl: image,
              itemTotal: item.price * item.quantity,
              lastChange: new Date(),
              seller: parseSeller(item.seller),
            } as Item;  // Cast to Item

            addItem(productToAdd, item.quantidade);
          }
        })
        notify({
          title: 'Seu carrinho está pronto',
          description: `${products.length === 1 ? 'foi adicionado' : 'foram adicionados'} ao seu carrinho`,
          type: 'success',
        })
      }, 2000)
    } catch (e) {
      // console.log('e', e)
    }
  }

  if (!orders || orders.length <= 0) {
    return <>Você não tem nenhum pedido</>
  }

  return (
    <div className={cn(s.root, className)}>
      <div className={s.content}>
        {abandonedCart && order ? (
          <>
            <strong>Seu último carrinho</strong>
            <div>
              {order.map((o: any) => (
                <CartItem item={o} canEdit={false} clean onChangeItemQuantity={() => {}} onDeleteItem={() => {}} />
              ))}
            </div>
            <br />
            <Button variant="secondary" onClick={() => addToCart(abandonedCart.id)}>
              Comprar novamente
            </Button>
            <div>
              <br />
            </div>
          </>
        ) : (
          <></>
        )}
        <>
          {ordersList.map((o: any) => (
            <OrderItem key={`oder-item-${o.id}`} order={o} />
          ))}
          <br />
          {!all && <Button onClick={() => setAll(!all)}>Ver todos os pedidos</Button>}
        </>
      </div>
    </div>
  )
}

export default OrderList
